// extracted by mini-css-extract-plugin
module.exports = {"cls1":"about-LeftSide-module--cls1--3Y50I","cls2":"about-LeftSide-module--cls2--26jnu about-LeftSide-module--cls1--3Y50I"};